module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_promesa.34392392.jpg";